import { PAGE_KEY } from '@/constants/state'
import { useBorrowMarketsSearchState } from '@/hooks/useBorrowMarketsSearchState'
import { ListPagination } from '../common/listPagination'

interface BorrowMarketsPaginationProps {
  currentPage: number
  itemsCount: number
  itemsPerPage: number
  className?: string
}

export const BorrowMarketsPagination = ({
  currentPage,
  itemsCount,
  itemsPerPage,
  className,
}: BorrowMarketsPaginationProps) => {
  const { updateSearchState } = useBorrowMarketsSearchState()

  return (
    <ListPagination
      currentPage={currentPage}
      itemsCount={itemsCount}
      itemsPerPage={itemsPerPage}
      onPageChange={(page) => updateSearchState([PAGE_KEY, page])}
      className={className}
    />
  )
}
